import { Stack, Box, FormLabel, Text } from '@chakra-ui/react';

import {
    stackStyling,
    formLabelStyling,
    formTextStyling,
} from 'components/forms/new/formStyles';

const PleaseNote = ({ darkMode, subText }) => (
    <Box sx={{ margin: '0 !important' }}>
        <Stack direction="row" sx={{ ...stackStyling() }}>
            <Box width={190}>
                <FormLabel
                    sx={{ ...formLabelStyling(darkMode), paddingTop: '15px' }}>
                    Please Note
                </FormLabel>
            </Box>
            <Text
                sx={{
                    ...formTextStyling(darkMode),
                    maxWidth: '500px',
                    paddingY: '15px',
                }}>
                {subText}
            </Text>
        </Stack>
    </Box>
);

export default PleaseNote;
